export default function Privacy() {
  return (
    <div className="bg-black text-white min-h-screen px-6 py-10">
      <h1 className="text-3xl font-bold mb-4">
        Kernel Solutions Inc Privacy Policy
      </h1>

      <p>
        <strong>Effective date: 04-JAN-2024</strong>
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Introduction</h2>
      <p>
        This Privacy Policy describes how Kernel Solutions Inc (“we”, “our”, or
        “us”) collects, uses, and protects your personal information when you
        visit our website. By using our site, you agree to the practices
        outlined below.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">
        Information We Collect
      </h2>
      <h3 className="text-xl mt-4">Personal Information</h3>
      <p>
        We may collect personal information you voluntarily provide, such as
        your name, email address, and contact details.
      </p>

      <h3 className="text-xl mt-4">Non-Personal Information</h3>
      <p>
        We may automatically collect information such as your IP address,
        browser type, pages visited, and timestamps using cookies and analytics
        tools.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">
        How We Use Your Information
      </h2>
      <p>Information we collect is used to:</p>
      <ul className="list-disc list-inside ml-4">
        <li>Operate and maintain our website</li>
        <li>Respond to inquiries or support requests</li>
        <li>Improve performance and user experience</li>
        <li>Send newsletters or updates (with your consent)</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Cookies and Tracking</h2>
      <p>
        We use cookies to enhance site functionality and analyze traffic. You
        can control cookie preferences through your browser settings.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Third-Party Services</h2>
      <p>
        We may use third-party providers for services like analytics, email
        delivery, and hosting. These providers may access data only to perform
        tasks on our behalf and are obligated not to disclose or use it for
        other purposes.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Data Sharing</h2>
      <p>
        We do not sell or rent your personal data. We may share it with service
        providers or when required by law.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Data Security</h2>
      <p>
        We implement technical and organizational safeguards to protect your
        data, but no method of internet transmission is completely secure.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Your Rights</h2>
      <p>You may request to:</p>
      <ul className="list-disc list-inside ml-4">
        <li>Access the personal data we hold about you</li>
        <li>Correct or delete your information</li>
        <li>Opt out of communications</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">
        Changes to This Policy
      </h2>
      <p>
        We may update this Privacy Policy periodically. Any changes will be
        posted on this page with an updated effective date.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Contact Us</h2>
      <p>
        If you have questions or concerns about this Privacy Policy, please
        contact us at
        <a href="mailto:privacy@kernelsol.com"> privacy@kernelsol.com</a> or at
        our mailing address below:
      </p>

      <address>
        Kernel Solutions Inc.
        <br />
        Attn: Data Privacy Officer
        <br />
        280 Shuman Blvd Suite 120
        <br />
        Naperville, IL 60563
      </address>
      <p></p>
    </div>
  );
}
